<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-dialog
    ref="dialog"
    v-model="dialog"
    width="290px"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="internalValue"
        :dense="dense"
        outlined
        prepend-inner-icon="mdi-calendar"
        readonly
        :rules="rules"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      :min="min"
      v-model="internalValue"
      @input="dialog=false"
    />
  </v-dialog>
</template>

<script>
export default {
  name: 'DateSelector',
  props: {
    value: {},
    rules: {},
    dense: {},
    min: {}
  },
  data: function () {
    return {
      internalValue: null,
      dialog: false
    }
  },
  watch: {
    value () {
      this.internalValue = this.value
    },
    internalValue () {
      this.$emit('input', this.internalValue)
    }
  }
}
</script>

<style scoped>

</style>
